var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thumbnail"},[_c('img',{attrs:{"src":_vm.page.thumbnail_url,"alt":"HallThumbnail"},on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.play.apply(null, arguments)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }